/**
 * <SessionStartedHere> — le repère « Historique de ce navigateur depuis 08:14 » en tête d'un fil de la séance du
 * masteur : ce qui précède est resté sur le navigateur où la séance a commencé. Son explication s'ouvre en info-bulle,
 * au survol et au toucher (qui n'a pas de survol). Lu par l'onglet « Fil » du live (`<TutorSessionReplay>`) et par le
 * fil hors live (`<TutorSessionFeed>`) : un même fait, dit d'une seule façon.
 */
import React, { useState } from "react"
import { Pressable, type StyleProp, type ViewStyle } from "react-native"

import { formatTime } from "../../../ports/primary/ui/formatters/dateFormatter"
import { Stack } from "../../atoms/containers/Stack"
import { Divider } from "../../atoms/Divider"
import { Text } from "../../atoms/typography/Text"

export type SessionStartedHereProps = {
    /** L'heure (ISO) depuis laquelle ce navigateur tient l'historique. */
    at: string
    /** Le prénom du champion, dont les résumés sont restés sur l'autre navigateur. */
    helperName: string
    style?: StyleProp<ViewStyle>
    testID?: string
}

const TEXTS = {
    label: (at: string) => `Historique de ce navigateur depuis ${at}`,
    note: (name: string) =>
        `Le reste de l'historique est resté sur le navigateur où la séance a commencé. Les résumés de ${name} et les rendus à valider sont là.`,
}

export function SessionStartedHere(props: SessionStartedHereProps) {
    const { at, helperName, style, testID } = props
    // État d'interface : l'explication ouverte au toucher, ou montrée le temps du survol.
    const [open, setOpen] = useState(false)
    const [hover, setHover] = useState(false)
    const shown = open || hover
    return (
        <Stack gap="1" style={style} testID={testID}>
            <Pressable
                onPress={() => setOpen(!open)}
                onHoverIn={() => setHover(true)}
                onHoverOut={() => setHover(false)}
                accessibilityRole="button"
                aria-expanded={shown}
            >
                <Divider label={TEXTS.label(formatTime(at))} icon="info-circle" spacing="1" />
            </Pressable>
            {shown && (
                <Text size="text-xs" color="text-muted" center>
                    {TEXTS.note(helperName)}
                </Text>
            )}
        </Stack>
    )
}
